/**
 * Shortens an address to `total` characters, split evenly between its head
 * and tail and joined by `separator`. The separator does not count toward
 * `total`. An address already within `total` is returned whole.
 *
 * `abbreviateAddress("4hFbN3HSmz4vBVNsv3MP8DfaKJKjAunrfzaXmQ4x1pQP", 8, "..")`
 * is `"4hFb..1pQP"`.
 */
export function abbreviateAddress(address: string, total: number, separator: string): string {
    if (address.length <= total) return address;
    const head = Math.ceil(total / 2);
    const tail = total - head;
    return `${address.slice(0, head)}${separator}${tail > 0 ? address.slice(-tail) : ""}`;
}
